import packageJSON from '../../package.json'
import { getCountryCode } from 'services/gelocation'
import {
    addToSessionStorage,
    getFromSessionStorage,
    getQueryParam,
    renewSession,
    TBetinSessionKey
} from 'utils'
import { v4 as uuidV4 } from 'uuid'

export const useSession = () => {
    renewSession()
    const location = getFromSessionStorage<TBetinSessionKey>('loc')
    const sid = getFromSessionStorage<TBetinSessionKey>('sid')

    if (!sid) {
        const newValue = getQueryParam('sid') || uuidV4()
        addToSessionStorage('sid', newValue)
        addToSessionStorage('ver', packageJSON.version)
        void getCountryCode()
        return { location, sid: newValue }
    }

    return { location, sid }
}

export const getSession = useSession
